import { Text, Flex, Box, Badge } from '@chakra-ui/react'

export default function TaskTitle({ children, important = false }: any) {
  return (
    <Flex alignItems={'center'} gap={1}>
      <Box h="8px" w="8px" bg="primary" rounded="full" />
      <Text fontWeight={'semibold'} fontSize={'md'} color="primary">
        {children}
      </Text>
      {important && <Badge colorScheme="purple">IMPORTANTE</Badge>}
    </Flex>
  )
}
